module.exports = __webpack_public_path__ + "img/slide_03_th.8eca64fa.jpg";